import React from 'react';
import { ComponentTitleWrapper } from './pageHeader.style';

export default props => {
  return <ComponentTitleWrapper className={"isoComponentTitle " + (props.noBorder == true ? 'noBorder' : '')}>
    {props.children}
  </ComponentTitleWrapper>;
}

